import ft from './ft.png'
import gbn from './gbn.png'
import itv from './ITV.png'
import itvSvg from './ITV.svg'
import skyNews from './skynews.png'
import theSun from './thesun.png'
import bbc from './bbcnews.png'
import dm from './dm.png'

export { ft, gbn, itv, itvSvg, skyNews, theSun, bbc, dm }

export const newsOutletImages = {
    'Financial Times': ft,
    'GB News': gbn,
    ITV: itv,
    'ITV SVG': itvSvg,
    'Sky News': skyNews,
    'The Sun': theSun,
    BBC: bbc,
    'Daily Mail': dm,
}

export default newsOutletImages
